<template>
    <div id="partners">
         <div class="col-md-4 col-sm-5 mt-3 p-2 pl-4 titleBlock">
            {{header}}
        </div>
        <ul>
            <li v-for="(pt,index) in partners" :key="index">
                <a :href="pt.url"><img v-bind:src="pt.image.src"></a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name:'partners',
    props:{
        header:{type:String,required:true},
        partners:{type:Object,required:true},
    },
    created(){
        // console.log(this.partners);
    }
}
</script>

<style scoped>

    #partners{
        margin-bottom: 20px;   
    }
    #partners ul {
        margin: 0px;
        padding: 0px;   
        border-top:2px solid black;
        margin: auto;
        display: flex;
        justify-content: space-around;        
    }
    #partners ul li{
        list-style: none;
        display: inline-block;
        padding: 20px 10px;
    }
    #partners ul li img{
        max-width: 70px;
    }

    #partners ul {
        margin: 0px;
        padding: 0px;   
        border-top:2px solid black;
        margin: auto;
        display: flex;
        justify-content: space-around;    
    }
    
    #partners li {
        display: flex !important;
        justify-content: center;
        flex-direction: column;
        text-align: center;  
    }
</style>





// WEBPACK FOOTER //
// src/components/overall_layouts/partners.vue